import React, { useEffect, useState } from "react";
import { useLanguage } from "../../languageContext";
import translations from "../../translation.json";
import { ApiUrl } from "../../ApiUrl";
import { toast } from "react-toastify";
import Loader from "../../loader";
import EventViewHeader from "../../components/EventViewHeader";
import ClientsFilterbar from "./../../components/clientsFilterbar";
import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";
import * as XLSX from "xlsx";
import { format } from "date-fns";

const StatusReport = ({
  isDarkMode,
  setDisplayComponent,
  setPrevDisplay,
  dealerships2,
  setIsLoading,
  eventScoped = false,
}) => {
  const { language } = useLanguage();
  const [clients, setClients] = useState([]);
  const [eventDetails, setEventDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const scopedEventId = eventScoped
    ? new URLSearchParams(window.location.search).get("event_id")
    : null;
  const [events, setEvents] = useState([]);
  const [checkedFields, setCheckedFields] = useState([]);
  const token = localStorage.getItem("token");
  const [filtersData, setFiltersData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedDealership, setSelectedDealership] = useState(null);
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const allfields = [
    {
      content: translations.commonFields.firstName[language],
      name: "first_name",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.lastName[language],
      name: "last_name",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.phone[language],
      name: "phone",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.email[language],
      name: "email",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.make[language],
      name: "make",
      type: "text",
      filterType: "",
      value: "",
    },

    {
      content: translations.createProspective.model[language],
      name: "model",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.usersPage.createUser.year[language],
      name: "year",
      type: "number",
      filterType: "",
      value: "",
    },
    {
      content: "KM",
      name: "km",
      type: "text",
      filterType: "",
      value: "",
    },

    {
      content: translations.clients.table.callStatus[language],
      name: "call_status",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.address[language],
      name: "address",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.city[language],
      name: "city",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.province[language],
      name: "province",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: "Activix ID",
      name: "activix_id",
      type: "number",
      filterType: "",
      value: "",
    },
    {
      content: translations.clients.table.prospectiveType[language],
      name: "prospect_type",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content:
        translations.forms.formFields.conquestSection.postalCode[language],
      name: "postal_code",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.officeNumber[language],
      name: "office_phone",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.appointments.appointment[language],
      name: "appointment",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.mobileNumber[language],
      name: "mobile_phone",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.language[language],
      name: "language",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.VIN[language],
      name: "vin",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.purchaseDate[language],
      name: "purchase_date",
      type: "date",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.lastServiceDate[language],
      name: "last_service_date",
      type: "date",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.prospectiveSource[language],
      name: "prospect_source",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.clients.table.prospectiveType[language],
      name: "prospect_type",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.createProspective.greetings[language],
      name: "greetings",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: "OG Rep",
      name: "og_rep",
      type: "text",
      filterType: "",
      value: "",
    },
  ];
  const textOptions = [
    {
      label: translations.commonFields.queryFilters.contain[language],
      value: "like",
    },
    {
      label: translations.commonFields.queryFilters.notContain[language],
      value: "not like",
    },
    {
      label: translations.commonFields.queryFilters.equal[language],
      value: "=",
    },
    {
      label: translations.commonFields.queryFilters.notEqual[language],
      value: "!=",
    },
  ];
  const textOptions2 = [
    {
      label: translations.commonFields.queryFilters.equal[language],
      value: "=",
    },
    {
      label: translations.commonFields.queryFilters.notEqual[language],
      value: "!=",
    },
  ];
  const appointmentOption = [
    { label: translations.dropdown.yes[language], value: "1" },
    { label: translations.dropdown.no[language], value: "0" },
  ];
  const prospectiveSourceOptions = Object.keys(
    translations.createProspective.prospectiveSourceOptions
  ).map((key) => ({
    label: {
      en: translations.createProspective.prospectiveSourceOptions[key]["en"],
      fr: translations.createProspective.prospectiveSourceOptions[key]["fr"],
    },
    value: {
      en: translations.createProspective.prospectiveSourceOptions[key]["en"],
      fr: translations.createProspective.prospectiveSourceOptions[key]["fr"],
    },
  }));

  const prospectiveSourceOptions2 = [
    {
      label:
        translations.createProspective.prospectiveSourceOptions.opt1[language],
      value: translations.createProspective.prospectiveSourceOptions.opt1["en"],
    },
    {
      label:
        translations.createProspective.prospectiveSourceOptions.opt2[language],
      value: translations.createProspective.prospectiveSourceOptions.opt2["en"],
    },
    // {
    //   label:
    //     translations.createProspective.prospectiveSourceOptions.opt3[language],
    //   value: translations.createProspective.prospectiveSourceOptions.opt3["en"],
    // },
    // {
    //   label:
    //     translations.createProspective.prospectiveSourceOptions.opt4[language],
    //   value: translations.createProspective.prospectiveSourceOptions.opt4["en"],
    // },
    {
      label:
        translations.createProspective.prospectiveSourceOptions.opt5[language],
      value: translations.createProspective.prospectiveSourceOptions.opt5["en"],
    },
    {
      label:
        translations.createProspective.prospectiveSourceOptions.opt6[language],
      value: translations.createProspective.prospectiveSourceOptions.opt6["en"],
    },
    {
      label:
        translations.createProspective.prospectiveSourceOptions.opt7[language],
      value: translations.createProspective.prospectiveSourceOptions.opt7["en"],
    },
    {
      label:
        translations.createProspective.prospectiveSourceOptions.opt8[language],
      value: translations.createProspective.prospectiveSourceOptions.opt8["en"],
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await fetch(ApiUrl + `/api/user/status-report/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            private_event_ids: eventScoped ? [scopedEventId] : [],
          }),
        });
        const data = await res.json();
        if (data.status === "success") {
          // const newData = data.private_events.data;

          setClients(data.prospectives);
          const allAppointmentIds = data.prospectives && data.prospectives.length > 0 && data.prospectives.map(
            (appointment) => appointment.id
          );
          setSelectedRows(allAppointmentIds);

          // autoScrollMid();
        } else {
          toast.error(data.message);
        }
      } catch (err) {
        toast.error(translations.alertMessages.wentWrong[language]);
      } finally {
        setLoading(false);
      }
    };
    const getFiltersData = async () => {
      try {
        const res = await fetch(ApiUrl + "/api/user/get-fillter", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (data.status === "success") {
          const filteredFields = allfields?.filter(
            (field) => data?.fillter[field.name] === 1
          );

          setCheckedFields(filteredFields);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error("Error fetching brands", error);
        // Handle error or show a toast if needed
      }
    };
    if (token && (!eventScoped || scopedEventId)) {
      fetchData();
    } else {
      setLoading(false);
    }
    // getFiltersData();
  }, [eventScoped, scopedEventId, token]);

  useEffect(() => {
    if (!eventScoped || !scopedEventId || !token) return;

    const fetchEventDetails = async () => {
      try {
        const res = await fetch(ApiUrl + "/api/user/graph-dashboard", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ event_id: scopedEventId }),
        });
        const data = await res.json();
        if (data.status === "success") {
          setEventDetails(data.dealershipDetails);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        toast.error(translations.alertMessages.wentWrong[language]);
      }
    };

    fetchEventDetails();
  }, [eventScoped, scopedEventId, token, language]);

  const handleCheckboxChange = (appointmentId) => {
    setSelectedRows(
      (prevSelected) =>
        prevSelected.includes(appointmentId)
          ? prevSelected.filter((id) => id !== appointmentId) // Deselect if selected
          : [...prevSelected, appointmentId] // Add if not selected
    );
  };

  const handleSelectAllChange = () => {
    if (selectAll) {
      // Deselect all
      setSelectedRows([]);
    } else {
      // Select all appointments' IDs
      const allAppointmentIds = clients.map((appointment) => appointment.id);
      setSelectedRows(allAppointmentIds);
    }
    setSelectAll(!selectAll); // Toggle the state of selectAll
  };

  const getFilteredEvents = async (filterPost) => {
    // setLoading(true);
    setIsLoading(true);

    try {
      const res = await fetch(ApiUrl + "/api/user/status-report", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ...filterPost,
          private_event_ids: eventScoped
            ? [scopedEventId]
            : selectedEvents.map((event) => event.value),
        }),
      });
      const data = await res.json();
      if (data.status === "success") {
        toast.success(data.message);
        setClients(data.prospectives);
        const allAppointmentIds = data.prospectives && data.prospectives.length > 0 && data.prospectives.map(
          (appointment) => appointment.id
        );
        setSelectedRows(allAppointmentIds);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
      // setAllowScrollFetch(true);
      setIsLoading(false);
    }
  };

  const getEventsList = async (dealershipId) => {
    // setLoading(true);
    try {
      const res = await fetch(ApiUrl + "/api/user/p-events/" + dealershipId, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (data.status === "success") {
        const lists =
          data?.private_events &&
          data?.private_events.length > 0 &&
          data?.private_events.map((list) => {
            return { label: list?.nom_vp, value: list?.id };
          });

        setEvents(lists);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
      // setIsLoading(false);
    }
  };

  const getFilteredProspects = async (eventsList) => {
    setIsLoading(true);
    // setAllowScrollFetch(false);

    try {
      const res = await fetch(ApiUrl + "/api/user/status-report", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          private_event_ids: eventScoped ? [scopedEventId] : eventsList,
        }),
      });
      const data = await res.json();
      if (data.status === "success") {
        toast.success(data.message);
        setClients(data.prospectives);
        const allAppointmentIds = data.prospectives && data.prospectives.length > 0 && data.prospectives.map(
          (appointment) => appointment.id
        );
        setSelectedRows(allAppointmentIds);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      // setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
      // setAllowScrollFetch(true);
      setIsLoading(false);
    }
  };

  // const exportToExcel = () => {
  //   // Filter the selected appointments based on their IDs
  //   const selectedData = clients
  //     .filter((appointment) => selectedRows.includes(appointment.id)) // Only include selected appointments
  //     .map((appointment) => ({
  //       Prospect_ID: appointment?.id || "Null",
  //       Event_ID: appointment.private_event.nom_vp || "Null",
  //       Dealership: appointment?.private_event.dealership?.name || "Null",
  //       Prospect_Source: appointment?.prospect_source || "Null",
  //       Greetings: appointment?.greetings || "Null",
  //       First_Name: appointment?.first_name || "Null",
  //       Last_Name: appointment?.last_name || "Null",
  //       Phone_Number: appointment?.phone || "Null",
  //       Mobile_Number: appointment?.mobile_phone || "Null",
  //       Office_Number: appointment?.office_phone || "Null",
  //       Address: appointment?.address || "Null",
  //       City: appointment?.city || "Null",
  //       Province: appointment?.province || "Null",
  //       Postal_Code: appointment?.postal_code || "Null",
  //       Email: appointment?.email || "Null",
  //       Make: appointment.make || "Null",
  //       Model: appointment.model || "Null",
  //       Year: appointment.year || "Null",
  //       Purchase_Date: appointment.purchase_date || "Null",
  //       Last_Service_Date: appointment.last_service_date || "Null",
  //       KM: appointment.km || "Null",
  //       VIN: appointment.vin || "Null",
  //       Representative: appointment?.og_rep || "Null",
  //       Call_Status: appointment?.call_status || "Null",
  //       Appointment_Date:
  //         appointment?.appointments[0]?.appointment_date || "Null",
  //       Appointment_Time:
  //         appointment?.appointments[0]?.appointment_time || "Null",
  //       Confirmation_Status:
  //         appointment?.appointments[0]?.confirmation_status || "Null",
  //       Visit_Status: appointment?.appointments[0]?.visit_status || "Null",
  //       No_Show_Status: appointment?.appointments[0]?.no_show_status || "Null",
  //     }));

  //   // Generate the Excel sheet
  //   const worksheet = XLSX.utils.json_to_sheet(selectedData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Appointments");

  //   // Save the file
  //   XLSX.writeFile(
  //     workbook,
  //     `Status Report ${format(new Date(), "dd/MM/yyyy")}.xlsx`
  //   );
  // };
  const exportToExcel = () => {
    const headers = {
      Prospect_ID:  "ID",
      Event_ID: translations.forms.privateEventformFields.title[language] + " ID" || "Event ID",
      Dealership: translations.commonWords.dealership[language] || "Dealership",
      Prospect_Source: translations.createProspective.prospectiveSource[language] || "Prospect Source",
      Prospect_Type: translations.clients.table.prospectiveType[language] || "Prospect Type",
      Greetings: translations.createProspective.greetings[language] || "Greetings",
      First_Name: translations.commonFields.firstName[language] || "First Name",
      Last_Name: translations.commonFields.lastName[language] || "Last Name",
      Phone_Number: translations.quickCreationModal.phoneNumber[language] || "Phone Number",
      Mobile_Number: translations.commonFields.mobileNumber[language] || "Mobile Number",
      Office_Number: translations.createProspective.officeNumber[language] || "Office Number",
      Address: translations.commonFields.address[language] || "Address",
      City: translations.commonFields.city[language] || "City",
      Province: translations.commonFields.province[language] || "Province",
      Postal_Code: translations.forms.formFields.conquestSection.postalCode[language] || "Postal Code",
      Email: translations.commonFields.email[language] || "Email",
      Make: translations.createProspective.make[language] || "Make",
      Model: translations.createProspective.model[language] || "Model",
      Year: translations.usersPage.createUser.year[language] || "Year",
      Purchase_Date: translations.createProspective.purchaseDate[language] || "Purchase Date",
      Last_Service_Date: translations.createProspective.lastServiceDate[language] || "Last Service Date",
      KM: "KM",
      VIN: translations.createProspective.VIN[language] || "VIN",
      Representative: translations.commonWords.usersTypes.representative[language] || "Representative",
      Call_Status: translations.clients.table.callStatus[language] || "Call Status",
      Appointment_Date: translations.clients.table.appointmentDate[language] || "Appointment Date",
      Appointment_Time: translations.clients.table.appointmentTime[language] || "Appointment Time",
      Confirmation_Status: translations.createProspective.confirmationStatus[language] || "Confirmation Status",
      Visit_Status: translations.createProspective.visitStatus[language] || "Visit Status",
      No_Show_Status: translations.createProspective.noShowSatus[language] || "No Show Status",
      appointment_comment :   translations.createProspective.appointmentComment[language] || "appointment_comment",
      import_note :   translations.createProspective.import_note[language] || "import_note",
      group_code :   translations.createProspective.group_code[language] || "group_code",

    };
  
   
    const selectedData = clients
      .filter((appointment) => selectedRows.includes(appointment.id)) 
      .map((appointment) => ({
        [headers.Prospect_ID]: appointment?.id || "",
        [headers.Event_ID]: appointment.private_event?.nom_vp || "",
        [headers.Dealership]: appointment?.private_event?.dealership?.name || "",
        [headers.Prospect_Source]: appointment?.prospect_source || "",
        [headers.Prospect_Type]: appointment?.prospect_type || "",
        [headers.Greetings]: appointment?.greetings || "",
        [headers.First_Name]: appointment?.first_name || "",
        [headers.Last_Name]: appointment?.last_name || "",
        [headers.Phone_Number]: appointment?.phone || "",
        [headers.Mobile_Number]: appointment?.mobile_phone || "",
        [headers.Office_Number]: appointment?.office_phone || "",
        [headers.Address]: appointment?.address || "",
        [headers.City]: appointment?.city || "",
        [headers.Province]: appointment?.province || "",
        [headers.Postal_Code]: appointment?.postal_code || "",
        [headers.Email]: appointment?.email || "",
        [headers.Make]: appointment?.make || "",
        [headers.Model]: appointment?.model || "",
        [headers.Year]: appointment?.year || "",
        [headers.Purchase_Date]: appointment?.purchase_date || "",
        [headers.Last_Service_Date]: appointment?.last_service_date || "",
        [headers.KM]: appointment?.km || "",
        [headers.VIN]: appointment?.vin || "",
        [headers.Representative]: appointment?.og_rep || "",
        [headers.Call_Status]: appointment?.call_status || "",
        [headers.Appointment_Date]: appointment?.appointments?.[0]?.appointment_date || "",
        [headers.Appointment_Time]: appointment?.appointments?.[0]?.appointment_time || "",
        [headers.Confirmation_Status]: appointment?.appointments?.[0]?.confirmation_status || "",
        [headers.Visit_Status]: appointment?.appointments?.[0]?.visit_status || "",
        [headers.No_Show_Status]: appointment?.appointments?.[0]?.no_show_status || "",
        [headers.appointment_comment] :  appointment?.appointments[0]?.appointment_comment,
        [headers.import_note] :  appointment?.import_note,
        [headers.group_code] :  appointment?.group_code

      }));
  
  
    const worksheet = XLSX.utils.json_to_sheet(selectedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Appointments");
  
 
    const fileName = `Status Report ${format(new Date(), "dd/MM/yyyy")}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  return (
    <div>
      {!loading ? (
        <div className="container maincont">
          <div id="app" className="appcountainer2">
            {eventScoped && (
              <EventViewHeader
                showStatusReport
                eventId={scopedEventId}
                dealershipDetails={eventDetails}
                isDarkMode={isDarkMode}
                setDisplayComponent={setDisplayComponent}
              />
            )}
            <ClientsFilterbar
              isDarkMode={isDarkMode}
              allfields={allfields}
              checkedFields={checkedFields}
              setCheckedFields={setCheckedFields}
              textOptions={textOptions}
              textOptions2={textOptions2}
              appointmentOption={appointmentOption}
              prospectiveSourceOptions={prospectiveSourceOptions2}
              filtersData={filtersData}
              setFiltersData={setFiltersData}
              // filterOption={filterOption}
              // setFilterOption={setFilterOption}
              // dealerOptions={dealerOptions}
              // repOptions2={repOptions2}
              // managers={managers}
              // packageOptions={packageOptions}
              // animatorOptions={animatorOptions}
              getFilteredEvents={getFilteredEvents}
              // weekOptions={weekOptions}
            />
            <div className="row align-items-center justify-content-between pb-2">
              <div className="col-4 d-flex gap-3 align-items-center">
                <div>
                  <h2 id="h1" className={`${isDarkMode ? "darkthead" : ""}`}>
                    {translations.topAndsidebar.statusReport[language]}
                  </h2>
                </div>
              </div>
              <div className="col-8 gap-2 d-flex align-items-center justify-content-end">
                {!eventScoped && (
                  <>
                <div style={{ width: "250px" }}>
                  <Select
                    className="selectpicker w-100"
                    aria-labelledby="dealership-name-quick"
                    isClearable
                    options={dealerships2}
                    placeholder={translations["dropdown"].select[language]}
                    isSearchable={true}
                    maxMenuHeight={"120px"}
                    value={selectedDealership}
                    // value={
                    //   (filterOptions &&
                    //     filterOptions.length > 0 &&
                    //     filterOptions.find(
                    //       (option) => option.value === filterOption
                    //     )) || {
                    //     value: "",
                    //     label: translations["dropdown"].select[language],
                    //   }
                    // }
                    onChange={(selectedOption) => {
                      setSelectedDealership(selectedOption);
                      if (selectedOption) getEventsList(selectedOption.value);
                      else {
                        setSelectedEvents([]);
                        setSelectedRows([]);
                        getFilteredProspects([]);
                      }
                    }}
                    styles={{
                      input: (provided) => ({
                        ...provided,
                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                      }),
                      control: (provided, state) => ({
                        ...provided,
                        backgroundColor: isDarkMode ? "transparent" : "white",
                        border: state.isFocused
                          ? "1px solid #80bdff"
                          : isDarkMode
                          ? "1px solid #495057"
                          : "1px solid #dee2e6", // Adjust the border color for focus
                        boxShadow: state.isFocused
                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                          : "none", // Bootstrap's box shadow for focus
                        borderRadius: ".45rem",
                      }),
                      valueContainer: (provided) => ({
                        ...provided,
                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none", // Hide the indicator separator
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                        color: isDarkMode ? "#ffffff" : "#868686",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        color: isDarkMode ? "#ffffff" : "black",
                        backgroundColor: isDarkMode ? "#1f2023" : "white",
                        margin: "0", // Remove default margin
                        zIndex: "9999",
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                        // Additional styles for placeholder
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: isDarkMode ? "#ffffff" : "",
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        color: isDarkMode ? "#ffffff" : "black",
                        backgroundColor: state.isHovered
                          ? "#80bdff"
                          : isDarkMode
                          ? "#1f2023"
                          : "white",
                        ":hover": {
                          backgroundColor: isDarkMode ? "#34DBB4" : "#34DBB4",
                        },
                      }),
                    }}
                  />
                </div>
                <div
                  style={{ width: "250px" }}
                  className={
                    isDarkMode ? "statusDropdownDark" : "statusDropdown"
                  }
                >
                  <MultiSelect
                    options={events}
                    className={`selectpicker w-100 ${
                      isDarkMode ? "reactMultiDark" : ""
                    }`}
                    value={selectedEvents}
                    onChange={(selected) => {
                      setSelectedEvents(selected);
                      const selectedValues = selected.map(
                        (option) => option.value
                      );
                      getFilteredProspects(selectedValues);
                    }}
                    // isOpen
                    disabled={!selectedDealership}
                    disableSearch
                    labelledBy={translations["dropdown"].select[language]}
                  />
                  {/* <Select
                    className="selectpicker w-100"
                    aria-labelledby="dealership-name-quick"
                    // isClearable
                    isDisabled={!selectedDealership}
                    options={events}
                    placeholder={translations["dropdown"].select[language]}
                    isSearchable={false}
                    isMulti
                    maxMenuHeight={"120px"}
                    // value={
                    //   (filterOptions &&
                    //     filterOptions.length > 0 &&
                    //     filterOptions.find(
                    //       (option) => option.value === filterOption
                    //     )) || {
                    //     value: "",
                    //     label: translations["dropdown"].select[language],
                    //   }
                    // }
                    onChange={(selectedOption) => {
                      setSelectedEvents(selectedOption);
                      if (selectedOption) {
                        const eventsList =
                          selectedOption &&
                          selectedOption.map((event) => {
                            return event.value;
                          });
                      }
                    }}
                    // maxMenuHeight={"130px"}
                    styles={{
                      input: (provided) => ({
                        ...provided,
                        color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                      }),
                      control: (provided, state) => ({
                        ...provided,
                        backgroundColor: isDarkMode ? "transparent" : "white",
                        border: state.isFocused
                          ? "1px solid #80bdff"
                          : isDarkMode
                          ? "1px solid #495057"
                          : "1px solid #dee2e6", // Adjust the border color for focus
                        boxShadow: state.isFocused
                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                          : "none", // Bootstrap's box shadow for focus
                        borderRadius: ".45rem",
                      }),
                      valueContainer: (provided) => ({
                        ...provided,
                        padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none", // Hide the indicator separator
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                        color: isDarkMode ? "#ffffff" : "#868686",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        color: isDarkMode ? "#ffffff" : "black",
                        backgroundColor: isDarkMode ? "#1f2023" : "white",
                        margin: "0", // Remove default margin
                        zIndex: "9999",
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                        // Additional styles for placeholder
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: isDarkMode ? "#ffffff" : "",
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        color: isDarkMode ? "#ffffff" : "black",
                        backgroundColor: state.isHovered
                          ? "#80bdff"
                          : isDarkMode
                          ? "#1f2023"
                          : "white",
                        ":hover": {
                          backgroundColor: isDarkMode ? "#34DBB4" : "#34DBB4",
                        },
                      }),
                    }}
                  /> */}
                </div>
                  </>
                )}
                <div
                  className="btn-group"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    id=""
                    type="button"
                    disabled={eventScoped ? !scopedEventId : selectedEvents.length === 0}
                    className="btn admin-btn btn-primary"
                    data-bs-target="#clientFiltersidebar"
                    data-bs-toggle="offcanvas"
                    aria-bs-controls="offcanvasmain"
                  >
                    <i className="bi bi-search"></i>{" "}
                  </button>
                </div>
              </div>
            </div>
            <div className="row align-items-center justify-content-between">
              <div className="col-4 d-flex gap-3 align-items-center">
                <div
                  className="row align-items-center"
                  style={{ minHeight: "40px" }}
                >
                  <div className="col-3">
                    {selectedRows && selectedRows.length > 0 && (
                      <button
                        type="button"
                        className="client-btn d-flex align-items-center gap-2"
                        onClick={exportToExcel}
                      >
                        <i className="bi bi-upload"></i>
                        {translations.commonWords.export[language]}{" "}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div
              // className="pt-4"
              // style={{
              //   display: "flex",
              //   flexDirection: "column",
              //   justifyContent: "space-between",
              // }}
              // ref={containerRef}
              style={{
                display: "flex",
                flexDirection: "column",
                overflowX: "auto",
                justifyContent: "space-between",
                height: "calc(100vh - 260px)",
              }}
            >
              <table className="table table-hover text-center align-middle">
                <thead style={{ position: "sticky", top: "0", zIndex: "1" }}>
                  <tr>
                    {/* <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                    >
                      {
                        <input
                          type="checkbox"
                          className=""
                          checked={selectAll}
                          onChange={handleSelectAllChange}
                        />
                      }
                    </th> */}
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                    >
                      ID
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "150px" : "170px",
                      }}
                    >
                      {translations.forms.privateEventformFields.title[
                        language
                      ] + " ID"}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{ minWidth: "150px" }}
                    >
                      {translations.commonWords.dealership[language]}
                    </th>

                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "140px" : "165px",
                      }}
                    >
                      {
                        translations.createProspective.prospectiveSource[
                          language
                        ]
                      }
                    </th>
                     <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "140px" : "165px",
                      }}
                    >
                      {
                        translations.clients.table.prospectiveType[
                          language
                        ]
                      }
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "125px" : "150px",
                      }}
                    >
                      {translations.createProspective.greetings[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "100px" : "100px",
                      }}
                    >
                      {translations.commonFields.firstName[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "100px" : "135px",
                      }}
                    >
                      {translations.commonFields.lastName[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "130px" : "180px",
                      }}
                    >
                      {translations.quickCreationModal.phoneNumber[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "160px" : "180px",
                      }}
                    >
                      {translations.commonFields.mobileNumber[language]}
                    </th>

                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "130px" : "155px",
                      }}
                    >
                      {translations.createProspective.officeNumber[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "100px" : "100px",
                      }}
                    >
                      {translations.commonFields.address[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "100px" : "100px",
                      }}
                    >
                      {translations.commonFields.city[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "100px" : "100px",
                      }}
                    >
                      {translations.commonFields.province[language]}
                    </th>

                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "150px" : "130px",
                      }}
                    >
                      {
                        translations.forms.formFields.conquestSection
                          .postalCode[language]
                      }
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "150px" : "100px",
                      }}
                    >
                      {translations.commonFields.email[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "100px" : "100px",
                      }}
                    >
                      {translations.createProspective.make[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "100px" : "100px",
                      }}
                    >
                      {translations.createProspective.model[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{ minWidth: language === "en" ? "95px" : "90px" }}
                    >
                      {translations.usersPage.createUser.year[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "150px" : "130px",
                      }}
                    >
                      {translations.createProspective.purchaseDate[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "150px" : "180px",
                      }}
                    >
                      {translations.createProspective.lastServiceDate[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{ minWidth: language === "en" ? "95px" : "90px" }}
                    >
                      KM
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{ minWidth: language === "en" ? "95px" : "90px" }}
                    >
                      {translations.createProspective.VIN[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{ minWidth: language === "en" ? "95px" : "90px" }}
                    >
                      {
                        translations.commonWords.usersTypes.representative[
                          language
                        ]
                      }
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "100px" : "130px",
                      }}
                    >
                      {translations.clients.table.callStatus[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "160px" : "180px",
                      }}
                    >
                      {translations.clients.table.appointmentDate[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "160px" : "190px",
                      }}
                    >
                      {translations.clients.table.appointmentTime[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "180px" : "190px",
                      }}
                    >
                      {
                        translations.createProspective.confirmationStatus[
                          language
                        ]
                      }
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "150px" : "160px",
                      }}
                    >
                      {translations.createProspective.visitStatus[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "150px" : "160px",
                      }}
                    >
                      {translations.createProspective.noShowSatus[language]}
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "220px" : "150px",
                      }}
                    >
                      {
                              translations.createProspective.appointmentComment[
                                language
                              ]
                            }
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "220px" : "150px",
                      }}
                    >
                      {
                             translations.createProspective.import_note[language]
                            }
                    </th>
                    <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "220px" : "150px",
                      }}
                    >
                      {
                             translations.createProspective.group_code[language]
                            }
                    </th>
                  </tr>
                </thead>
                {clients && !loading && (
                  <tbody id="">
                    {clients && clients.length > 0 ? (
                      clients.map((client, index) => {
                        return (
                          <>
                            <tr className="result-box" key={client?.id}>
                              {/* <td className="fw-bold">
                                {
                                  <input
                                    type="checkbox"
                                    className=""
                                    checked={selectedRows.includes(client.id)}
                                    onChange={() =>
                                      handleCheckboxChange(client.id)
                                    }
                                  />
                                }
                              </td> */}
                              <th className="custID" scope="row">
                                {client?.id}
                              </th>
                              <td className="dlrname">
                                {client?.private_event.nom_vp}
                              </td>
                              <td className="dlrname">
                                {client?.private_event.dealership?.name}
                              </td>
                              <td className="dlrname">
                                {client?.prospect_source
                                  ? (() => {
                                      const matchedOption =
                                        prospectiveSourceOptions.find(
                                          (option) =>
                                            option.value.en?.toLowerCase() ===
                                              client?.prospect_source?.toLowerCase() ||
                                            option.value.fr?.toLowerCase() ===
                                              client?.prospect_source?.toLowerCase()
                                        );

                                      // Return the label in the current language if a match is found
                                      return matchedOption
                                        ? matchedOption.label[language]
                                        : client?.prospect_source;
                                    })()
                                  : ""}
                              </td>
                              <td className="dlrname">{client?.prospect_type}</td>

                              <td className="dlrname">{client?.greetings}</td>

                              <td className="dlrname">{client?.first_name}</td>
                              <td className="dlrname">{client?.last_name}</td>
                              <td className="salesrep">{client?.phone}</td>
                              <td className="salesrep">
                                {client?.mobile_phone}
                              </td>
                              <td className="salesrep">
                                {client?.office_phone}
                              </td>
                              <td className="salesrep">{client?.address}</td>
                              <td className="salesrep">{client?.city}</td>
                              <td className="salesrep">{client?.province}</td>
                              <td className="salesrep">
                                {client?.postal_code}
                              </td>
                              <td className="salesrep">{client?.email}</td>
                              <td className="salesrep">{client?.make}</td>
                              <td className="salesrep">{client?.model}</td>
                              <td className="salesrep">{client?.year}</td>
                              <td className="salesrep">
                                {client?.purchase_date}
                              </td>
                              <td className="salesrep">
                                {client?.last_service_date}
                              </td>
                              <td className="salesrep">{client?.km}</td>
                              <td className="salesrep">{client?.vin}</td>

                              <td className="salesrep">{client?.og_rep}</td>
                              <td className="salesrep">
                                {client?.call_status}
                              </td>

                              <td className="salesrep">
                                {client?.appointments[0]?.appointment_date}
                              </td>
                              <td className="salesrep">
                                {client?.appointments[0]?.appointment_time}
                              </td>
                              <td className="salesrep">
                                {client?.appointments[0]?.confirmation_status}
                              </td>
                              <td className="salesrep">
                                {client?.appointments[0]?.visit_status}
                              </td>
                              <td className="salesrep">
                                {client?.appointments[0]?.no_show_status}
                              </td>
                              <td className="salesrep">
                                {client?.appointments[0]?.appointment_comment}
                              </td>
                              <td className="salesrep">
                                {client?.import_note}
                              </td>
                              <td className="salesrep">
                                {client?.group_code}
                              </td>
                            </tr>
                          </>
                        );
                      })
                    ) : (
                      <tr
                        className="align-middle"
                        style={{
                          position: "relative",
                          // height: "30px",
                          // zIndex: 10 + eventList.length - index,
                        }}
                      >
                        <td
                          style={{
                            background: `${
                              isDarkMode ? "transparent" : "white"
                            }`,
                            borderStyle: "none",
                          }}
                          colSpan={30}
                          className="text-center py-5"
                        >
                          <h4>
                            {translations.EventsPortal.noDataMessage[language]}
                          </h4>
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>
              {/* <div ref={bottomMarkerRef} style={{ height: "1px" }} /> */}
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default StatusReport;
